/*
Exterior Finishes
*/
import filters from '@/modules/standardItems/schemas/finish/filters'
import headers from '@/modules/standardItems/schemas/finish/headers'
import form from '@/modules/standardItems/schemas/finish/form'

const name = 'Exterior Finishes'
const id = 'wDyPq8dIljSFHsU7swVz'

export default {
  name,
  id,
  filters,
  headers,
  form
}
